import { AuthenticationException } from './authentication-exception';

export class AccountExpiredException extends AuthenticationException {}
